<template>
<div class="cfd-row">
    <div class="cfd-row-data">
        <div class="cfd-val">{{ instrument[column.MatchingFieldName].Text }}</div>
        <div class="cfd-key">{{ column.Header }}</div>
    </div>
    <div v-if="column.Help" class="cfd-help" :data-tipok-title="column.Help">
        <svg class="cfd-helper" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"/>
        </svg>
    </div>
</div>
</template>

<script>
export default {
    name: 'InstrumentsListItemDataItem',

    props: {
        instrument: {
            type: Object,
            required: true
        },
        column: {
            type: Object,
            required: true
        }
    },
};
</script>

<style scoped>
.cfd-row {
    display: flex;
    padding: 10px 16px;
}

.cfd-key {
    font-size: 13px;
    line-height: 20px;
    color: rgba(0, 0, 0, .54);
}

.cfd-help {
    flex-shrink: 0;
    position: relative;
    margin: -4px -12px -4px auto;
    width: 24px;
    height: 24px;
    padding: 12px;
    opacity: .54;
    transition: opacity .125s ease-in;
}

.cfd-help:hover {
    opacity: .87;
    transition-timing-function: ease-out;
}

.cfd-helper {
    max-width: 100%;
    height: auto;
}

@media (min-width: 720px) {
    .cfd-help {
        top: 8px;
        right: 6px;
        width: 20px;
        height: 20px;
        padding: 6px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/InstrumentsListItemDataItem.vue